import { DeckData, SeatDetail } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import { Box } from '@mui/material'
import SeatPriceMapWrapper from '../seatPriceMap'
import AircraftWrapper from './aircraft'

const Seat = ({
    seatData,
    selectedSeatOptions,
    handleAddSeat,
    handleRemoveSeat,
    formatCurrency,
    t
}: {
    seatData: DeckData
    selectedSeatOptions: Partial<SeatDetail>[]
    handleAddSeat: (seat: SeatDetail) => void
    handleRemoveSeat: (seat: SeatDetail) => void
    formatCurrency: (price: number) => string
    t: TranslationFunction<'itineraryPage.addons'>
}) => {
    const { seatPriceMap } = seatData || {}
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    height: { xs: '100%', lg: '500px' },
                    overflow: 'hidden',
                    background: 'skyblue',
                    flexDirection: { xs: 'column', lg: 'row' },
                    // Only apply flex properties on mobile/tablet, not desktop
                    flex: { xs: 1, lg: 'none' },
                    minHeight: { xs: 0, lg: 'auto' }
                }}
            >
                <SeatPriceMapWrapper seatPriceMap={seatPriceMap} formatCurrency={formatCurrency} t={t} />
                <AircraftWrapper
                    seatData={seatData}
                    selectedSeatOptions={selectedSeatOptions}
                    handleAddSeat={handleAddSeat}
                    handleRemoveSeat={handleRemoveSeat}
                    formatCurrency={formatCurrency}
                />
            </Box>
        </>
    )
}

export default Seat
